import { ERequestButtonActionTypes } from '../../actions/requestButton';
import { TReduxActions } from '../../types/redux';
import { IRequestButtonState } from '../../types/requestButton';

export const INITIAL_STATE: IRequestButtonState = {
  loading: false,
};

export function requestButtonReducer(state: IRequestButtonState = INITIAL_STATE, action: TReduxActions) {
  switch (action.type) {
    case ERequestButtonActionTypes.ToggleRequestButtonLoading:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
